import './header.css';
import logo from '../../assets/images/logo.svg';
import {NavLink, useNavigate} from "react-router-dom";
import AppContext from "../../contexts/appContext/app.context";
import {useContext} from "react";
const Header = () => {
    const isActive = ({isActive}: any) => isActive ? 'active' : '';
    const appCtx = useContext(AppContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        appCtx.doLogout();
        navigate('');
    }

    return(
        <header>
            <div className="content-section flex hr-space-between">
                <div className="logo flex gap-10">
                    <div className="icon logo-icon">
                        <img src={logo} alt=""/>
                    </div>
                    <div className="sf-bold font-16">
                        Onboard Fleet<br/> Services
                    </div>
                </div>

                <nav className={'flex gap-0 grey-color sf-medium font-15'}>
                    <NavLink to={'dashboard'} className={isActive}>Dashboard</NavLink>
                    <NavLink to={'trips'} className={isActive}>Trips</NavLink>
                    <NavLink to={'liveTrack'} className={isActive}>Live Track</NavLink>
                    <NavLink to={'drivers'} className={isActive}>Drivers</NavLink>
                    {/*<NavLink to={'vehicles'} className={isActive}>Vehicles</NavLink>*/}
                    <NavLink to={'videoTelematics'} className={isActive}>Video  Telematics</NavLink>
                    <a>Reports</a>
                    <a>Settings</a>
                    {/*<div className={'flex gap-20'}>*/}
                    {/*    <div className="">John</div>*/}
                    {/*    <div className="icon width-12"><img src={downArrow} alt=""/></div>*/}
                    {/*</div>*/}
                    <div className="drop-down round-corner-12 transparent width-100">
                        <div className="drop-down-header">
                            <div className={'drop-down-title flex gap-20'}>John
                            </div>
                        </div>
                        <div className="drop-down-content">
                            <ul className="drop-down-list line-40">
                                <li className={'cursor-pointer'} onClick={handleLogout}>Logout</li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;
